/**
 * “Simple, Fast, Efficient” — three steps with oversized background numerals.
 * Content from `documents/Web Version/website-standalone.html` (`steps` + `#how-it-works`).
 */

const steps = [
  {
    number: '01',
    title: 'Create Auction',
    desc: 'Set up your procurement requirements with predefined specification and invite Qualified vendors',
  },
  {
    number: '02',
    title: 'Live Bidding',
    desc: 'Watch as vendors compete in real-time to offer the best price.',
  },
  {
    number: '03',
    title: 'Award Contract',
    desc: 'Analyze bids and award to the most qualified vendor.',
  },
] as const;

export function LandingHowItWorksSection() {
  return (
    <section id="how-it-works" className="scroll-mt-24 bg-white py-20 md:py-28 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <header className="text-left max-w-3xl mb-16 md:mb-20 lg:mb-24">
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-slate-900 tracking-tight leading-[1.08] mb-6">
            Simple, Fast,
            <br />
            Efficient.
          </h2>
          <p className="text-slate-500 text-base sm:text-lg font-medium leading-relaxed max-w-2xl">
            We&apos;ve simplified the procurement process so you can focus on what matters most: your business.
          </p>
        </header>

        <div className="grid md:grid-cols-3 gap-14 md:gap-10 lg:gap-16">
          {steps.map((s) => (
            <div key={s.number} className="relative min-h-[140px] md:min-h-[180px] text-left">
              <span
                className="absolute -left-1 md:left-0 top-0 font-black leading-none text-slate-100 select-none pointer-events-none z-0 tabular-nums
                  text-[5.5rem] sm:text-[6.5rem] md:text-[7rem] lg:text-[8.5rem]"
                aria-hidden
              >
                {s.number}
              </span>
              <div className="relative z-10 pt-4 md:pt-10 pl-2 md:pl-4">
                <h3 className="text-xl md:text-2xl font-black text-slate-900 mb-3">{s.title}</h3>
                <p className="text-slate-500 font-medium leading-relaxed text-[15px] md:text-base">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
